var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-item"},[_c('div',{staticClass:"fel"},[_c('div',{staticClass:"fel-label"},[_vm._v("Currency")]),_vm._l((_vm.currencies),function(item,index){return _c('FilterMainCheckBox',{key:index,ref:`Currency-${index}`,refInFor:true,attrs:{"checkbox-name":item.text,"loading":_vm.loading},on:{"change":_vm.change}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }